export const macroTargetingGroupdEndpoint = `macro-targeting-groups`;
